import _classCallCheck from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _assertThisInitialized from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/assertThisInitialized";
import React from 'react';
import Utils from '../utils/utils';
import Mixins from '../utils/mixins';
import __reactComponentDispatchEvent from '../runtime-helpers/react-component-dispatch-event.js';
import __reactComponentSlots from '../runtime-helpers/react-component-slots.js';
import __reactComponentSetProps from '../runtime-helpers/react-component-set-props.js';

var F7AccordionItem =
/*#__PURE__*/
function (_React$Component) {
  _inherits(F7AccordionItem, _React$Component);

  function F7AccordionItem(props, context) {
    var _this;

    _classCallCheck(this, F7AccordionItem);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(F7AccordionItem).call(this, props, context));
    _this.__reactRefs = {};

    (function () {
      Utils.bindMethods(_assertThisInitialized(_assertThisInitialized(_this)), 'onBeforeOpen onOpen onOpened onBeforeClose onClose onClosed'.split(' '));
    })();

    return _this;
  }

  _createClass(F7AccordionItem, [{
    key: "onBeforeOpen",
    value: function onBeforeOpen(el, prevent) {
      if (this.eventTargetEl !== el) return;
      this.dispatchEvent('accordionBeforeOpen accordion:beforeopen', prevent);
    }
  }, {
    key: "onOpen",
    value: function onOpen(el) {
      if (this.eventTargetEl !== el) return;
      this.dispatchEvent('accordionOpen accordion:open');
    }
  }, {
    key: "onOpened",
    value: function onOpened(el) {
      if (this.eventTargetEl !== el) return;
      this.dispatchEvent('accordionOpened accordion:opened');
    }
  }, {
    key: "onBeforeClose",
    value: function onBeforeClose(el, prevent) {
      if (this.eventTargetEl !== el) return;
      this.dispatchEvent('accordionBeforeClose accordion:beforeclose', prevent);
    }
  }, {
    key: "onClose",
    value: function onClose(el) {
      if (this.eventTargetEl !== el) return;
      this.dispatchEvent('accordionClose accordion:close');
    }
  }, {
    key: "onClosed",
    value: function onClosed(el) {
      if (this.eventTargetEl !== el) return;
      this.dispatchEvent('accordionClosed accordion:closed');
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var props = this.props;
      var className = props.className,
          id = props.id,
          style = props.style,
          opened = props.opened;
      var classes = Utils.classNames(className, 'accordion-item', {
        'accordion-item-opened': opened
      }, Mixins.colorClasses(props));
      return React.createElement('div', {
        id: id,
        style: style,
        className: classes,
        ref: function ref(__reactNode) {
          _this2.__reactRefs['el'] = __reactNode;
        }
      }, this.slots['default']);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var self = this;
      var el = self.refs.el;
      if (!el || !self.$f7) return;
      var f7 = self.$f7;
      f7.off('accordionBeforeOpen', self.onBeforeOpen);
      f7.off('accordionOpen', self.onOpen);
      f7.off('accordionOpened', self.onOpened);
      f7.off('accordionBeforeClose', self.onBeforeClose);
      f7.off('accordionClose', self.onClose);
      f7.off('accordionClosed', self.onClosed);
      delete this.eventTargetEl;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var self = this;
      var el = self.refs.el;
      if (!el) return;
      self.eventTargetEl = el;
      self.$f7ready(function (f7) {
        f7.on('accordionBeforeOpen', self.onBeforeOpen);
        f7.on('accordionOpen', self.onOpen);
        f7.on('accordionOpened', self.onOpened);
        f7.on('accordionBeforeClose', self.onBeforeClose);
        f7.on('accordionClose', self.onClose);
        f7.on('accordionClosed', self.onClosed);
      });
    }
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(events) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return __reactComponentDispatchEvent.apply(void 0, [this, events].concat(args));
    }
  }, {
    key: "slots",
    get: function get() {
      return __reactComponentSlots(this.props);
    }
  }, {
    key: "refs",
    get: function get() {
      return this.__reactRefs;
    },
    set: function set(refs) {}
  }]);

  return F7AccordionItem;
}(React.Component);

__reactComponentSetProps(F7AccordionItem, Object.assign({
  id: [String, Number],
  className: String,
  style: Object,
  opened: Boolean
}, Mixins.colorProps));

F7AccordionItem.displayName = 'f7-accordion-item';
export default F7AccordionItem;